import { yup } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

export const validationSchema = (t) => yup.object({
    firstName: yup
        .string()
        .required(t(I18N_NAMESPACE, "forms.profileForm.fields.firstName.requireMessage")),
    lastName: yup
        .string()
        .required(t(I18N_NAMESPACE, "forms.profileForm.fields.lastName.requireMessage")),
    avatar: yup
        .mixed()
        .nullable()
        .test("fileFormat", t(I18N_NAMESPACE, "forms.profileForm.fields.avatar.fileFormat"), (value) => {
            return !value || typeof value === "string" || value?.type?.includes("image/")
        }),
})
